import {defineStore} from "pinia";
import {computed, ref} from "vue";

declare global {
    interface Window {
        user: any;
    }
}

export const useUserStore = defineStore('user', () => {
    const user = ref<string | null>(null)

    const isAuth = computed(() => user.value)

    const authUser = (_user: string | null) => user.value = _user

    return {
        isAuth,
        authUser,
        user
    }
})